var _circle, _path, _ellipse, _ellipse2, _ellipse3, _ellipse4, _ellipse5, _ellipse6, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmoji0(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "rating-0",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 256,
    cy: 256,
    r: 256,
    fill: "#ffd93b"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M512 256c0 141.44-114.64 256-256 256-80.48                             0-152.32-37.12-199.28-95.28 43.92 35.52 99.84 56.72                             160.72 56.72 141.36 0 256-114.56 256-256                             0-60.88-21.2-116.8-56.72-160.72C474.8 103.68 512                             175.52 512 256z",
    fill: "#f4c534"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    transform: "scale(-1) rotate(31.21 715.433                                 -595.455)",
    cx: 166.318,
    cy: 199.829,
    rx: 56.146,
    ry: 56.13,
    fill: "#fff"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    transform: "rotate(-148.804 180.87                                     175.82)",
    cx: 180.871,
    cy: 175.822,
    rx: 28.048,
    ry: 28.08,
    fill: "#3e4347"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    transform: "rotate(-113.778 194.434                                         165.995)",
    cx: 194.433,
    cy: 165.993,
    rx: 8.016,
    ry: 5.296,
    fill: "#5a5f63"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    transform: "scale(-1)                                             rotate(31.21 715.397 -1237.664)",
    cx: 345.695,
    cy: 199.819,
    rx: 56.146,
    ry: 56.13,
    fill: "#fff"
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    transform: "rotate(-148.804                                                 360.25 175.837)",
    cx: 360.252,
    cy: 175.84,
    rx: 28.048,
    ry: 28.08,
    fill: "#3e4347"
  })), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    transform: "scale(-1)                                                     rotate(66.227 254.508                                                     -573.138)",
    cx: 373.794,
    cy: 165.987,
    rx: 8.016,
    ry: 5.296,
    fill: "#5a5f63"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M370.56 344.4c0                                                         7.696-6.224 13.92-13.92                                                         13.92H155.36c-7.616                                                         0-13.92-6.224-13.92-13.92s6.304-13.92                                                         13.92-13.92h201.296c7.696.016                                                         13.904 6.224 13.904                                                         13.92z",
    fill: "#3e4347"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmoji0);
export default __webpack_public_path__ + "static/media/emoji0.7a89c31c0202f36ae98b010d5f941d1f.svg";
export { ForwardRef as ReactComponent };